import { useContext, useRef, useState } from "react";
import Button from "../buttons/Button";
import FileUpload from "../input/FileUpload";
import Input from "../input/Input";
import Select from "../select/Select";
import { appContext } from "../../service/AppContext";
import { registrationContex } from "../../service/RegisrationContext";
import { formatNumber } from "../../service/inputUtil";

export default function ExistingPermission({ onCompleted }) {

    // const [bankInfo,setBankInfo]
    const { user, setFetch } = useContext(appContext);
    const [lastFourDigits, setlastFourDigits] = useState('');
    const [billingDay, setBillingDay] = useState('');


    const formRef = useRef();

    const handleChange = (val) => {
        let value = formatNumber(val, { maxLength: 4 });
        setlastFourDigits(value);
    }


    const handleSubmit = (e) => {
        e.preventDefault();

        const formElement = formRef.current;
        const isValid = formElement.checkValidity();

        formElement.classList.add('submitted');

        const firstInvalidField = formElement.querySelector(":invalid");
        firstInvalidField?.focus();

        if (isValid) {
            const dataObject = new FormData(formElement);
            if (user?.id)
                dataObject.append('id', user?.id);
            setFetch({
                route: '/existing-permission', options: {
                    method: 'POST',
                    body: dataObject
                }
            })
            if (typeof (onCompleted) === 'function')
                onCompleted(e);
        }
    }

    return (
        <form ref={formRef} noValidate>
            {/* <div>
                <h4>פרטי הרשאה קיימת</h4>
            </div> */}
            <div className='bank-info-fields'>
                <Input label='4 ספרות אחרונות של אמצעי התשלום' name='last-four-digits' onChange={handleChange} value={lastFourDigits} pattern="[0-9]{4}" maxlength={4} required />
                <Select  className="biling-day" name='biling-day' label='תאריך בחודש לחיוב' onChange={setBillingDay} value={billingDay} required placeholder='בחרו יום בחודש' options={[5, 10, 15, 20, 25]} />
            </div>
            <Button type='button' onClick={handleSubmit} size='small' label='אישור וסיום' />
        </form>)
}